import { request } from "../../../apis";
import { getCurrency } from "../../../plugins/utils";
const CURRENCY = getCurrency();

//basic info
export const getSubordinateBasicInfo = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/child/info`,
    { ...params, page },
    true,
    false
  );
//data
export const getSubordinateUserData = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/child/trans`,
    {
      ...params,
      page,
    },
    true,
    false
  );

export const getSubordinateUserDetailData = ({ params, childId }) =>
  request(
    "get",
    `/${CURRENCY}/agent/child/game/${childId}`,
    {
      ...params,
    },
    true,
    false
  );

//agentData
export const getSubordinateAgentData = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/child/info`,
    {
      ...params,
      page,
    },
    true,
    false
  );
//memberData
export const getSubordinateMemberData = ({ params, page }) =>
  request(
    "get",
    `/${CURRENCY}/agent/child/trans`,
    {
      ...params,
      page,
    },
    true,
    false
  );
